
















































































































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Prop, Vue } from 'vue-property-decorator';


//@ts-ignore
import poa_avance_financieros from '@/mixins/axios/poa_avance_financieros'

//@ts-ignore
import poa_lineas_accion from '@/mixins/axios/poa_lineas_accion'
//@ts-ignore
import poa_capitulos_conacs from '@/mixins/axios/poa_capitulos_conacs'

//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {

  },
  data() {
    return {
       config: {
          spinner: false,
          step: 1,
          min: -10,
          max: 20000000000000000000000000000000,
          prefix: "",
          suffix: "",
          precision: 2,
         decimal: '.',
          thousands: ',',
          bootstrap: true,
          amend: false,
          masked: true,
          invalidMessage: 'Minimo es 0'
        },
         config2: {
          spinner: false,
          step: 1,
          min: -10,
          max: 20000000000000000000000000000000,
          prefix: "",
          suffix: "",
          precision: 2,
          decimal: '.',
          thousands: ',',
          bootstrap: true,
          amend: false,
          masked: true,
          invalidMessage: 'Minimo es 0'
        },
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
     

        id:null as any,

      poa_capitulos_conac_id:0,
     
     selectedvar:0,
         poa_capitulos_conacs:[] as any,
         
            planeado_1: null as any,
            planeado_2: null as any,
            planeado_3: null as any,
            planeado_4: null as any,              
            ejercido_1: null as any,
            ejercido_2: null as any,
            ejercido_3: null as any,
            ejercido_4: null as any,
            comentarios_1p:null,
comentarios_2p:null as any,
comentarios_3p:null as any,
comentarios_4p:null as any,
comentarios_1e:null as any,
comentarios_2e:null as any,
comentarios_3e:null as any,
comentarios_4e:null as any,

comentario_active:null as any,
              poa_avance_financierosdata:[] as any,poa_lineas_accion:[]as any,
            capitulosConac:[] as any,
      
    }
  },
     mixins: [poa_avance_financieros,poa_capitulos_conacs,poa_lineas_accion],
     validations: {
    
        /*   planeado_1: {
      required,
    },
      planeado_2: {
      required,
    },
      planeado_3: {
      required,
    },
      planeado_4: {
      required,
    },
      ejercido_1: {
      required,
    },
      ejercido_2: {
      required,
    },
      ejercido_3: {
      required,
    },
      ejercido_4: {
      required,
    },*/
      poa_capitulos_conac_id: {
      required,
    },

    


   
  },
  methods:{
    numberWithCommas(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
},
    calcejercido(row){
      let tot=0;

const array1 = [Number(String(row.ejercido_1).replaceAll(',',''))
,Number(String(row.ejercido_2).replaceAll(',',''))
 ,Number(String(row.ejercido_3).replaceAll(',','')),
  Number(String(row.ejercido_4).replaceAll(',','')),
  Number(String(row.planeado_1).replaceAll(',',''))
,Number(String(row.planeado_2).replaceAll(',',''))
 ,Number(String(row.planeado_3).replaceAll(',','')),
  Number(String(row.planeado_4).replaceAll(',',''))
  
  
  ];
const reducer = (accumulator, currentValue) => Number(accumulator) + Number(currentValue);
  
 
return this.numberWithCommas(array1.reduce(reducer,0));
    },
   async eliminar(row){
    this.capitulosConac= this.capitulosConac.filter(item => item.id !=row.id)
        
      },

     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });


 },
      
getMonto(id){
  let monto=this.poa_capitulos_conacs.filter(item => item.id ==id)[0].monto_cap;
return monto;
},
changuecolor(index,valor){

 ///this.capitulosConac.forEach(element => {
   let element =this.capitulosConac[index]
     let el=this.poa_capitulos_conacs.filter(item => item.id ==element.id)[0];
   if((Number(element.planeado_1)+Number(element.planeado_2)+Number(element.planeado_3)+Number(element.planeado_4))>el.monto_cap){
     element.color_active=''
  // }
  this.capitulosConac[index]=element;
}else{
  this.capitulosConac[index].color_active=''
}

},
 AsingarCapitulo(){
  
let exist=this.capitulosConac.filter(item => item.id ==this.selectedvar)[0];

          if(this.selectedvar!=0&&!exist){
let data=this.poa_capitulos_conacs.filter(item => item.id ==this.selectedvar)[0];
let capitulo={
id:data.id,
clave:data.clave,
nombre_capitulo:data.clave,
color_active:'#e5e9ec;',
planeado_1:0,
planeado_2:0,
planeado_3:0,
planeado_4:0,
ejercido_1:0,
ejercido_2:0,
ejercido_3:0,
ejercido_4:0,
total_planeado:0,
total_ejercido:0,
comentarios_1p:null,
comentarios_2p:null,
comentarios_3p:null,
comentarios_4p:null,
comentarios_1e:null,
comentarios_2e:null,
comentarios_3e:null,
comentarios_4e:null,


};
 this.capitulosConac.push(capitulo);
          }

         
      },
     
    

async getDataLineaAccion(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
id:id

};

let data= await this.GET_POA_LINEAS_ACCION(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_lineas_accion=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
 async getDataCapituloCONAC(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio,
idlinea:this.id

};

let data= await this.GET_POA_CAP_CONACS_LINEA(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_capitulos_conacs=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
     
     async GuardarData(){


       let dat={
      
avancesfinancieros:this.capitulosConac,
poa_lineas_acciones_id:this.id
       }
let data= await this.CREAR_POA_FINANCIEROS(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)


$('#modalCausa').modal('hide')
  //this.poa_avance_financierosdata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Avance Financiero, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
    async getData(id) {
  console.log(id,'----------lll----')
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
poa_lineas_acciones_id:id
};

let data= await this.GET_POA_FINANCIEROS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.capitulosConac=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},


    

  },
  mounted(){ this.getData(this.id);
      this.getDataCapituloCONAC();//this.getData();
      //alert('10')
     
      this.getDataLineaAccion();
  }
})
export default class Home extends Vue {

    @Prop() private id !:any;
}

